import { EnhancedProductViewContainerProps } from './EnhancedProductViewContainer'
import EnhancedProductViewContainer from './EnhancedProductViewContainerLazy'
export default EnhancedProductViewContainer
export type { EnhancedProductViewContainerProps }
